document.addEventListener('DOMContentLoaded', () => {

  function videoControls() {
    const play = document.querySelector('.tco-video-controls--play');
    const pause = document.querySelector('.tco-video-controls--pause');

    if ( !play ) {
      return;
    }

    const videoHome = document.querySelector('#homepage-video');
    const videoCareers = document.querySelector('#careers-video');
    let video = '';

    if ( videoHome ) {
      video = videoHome;
    } else if ( videoCareers ) {
      //video = videoCareers;
    }

    if( video ) {
      play.addEventListener('click', function(e) {
        video.play();
        play.classList.remove('is-paused');
        pause.classList.add('is-playing');
      });

      pause.addEventListener('click', function(e) {
        video.pause();
        play.classList.add('is-paused');
        pause.classList.remove('is-playing');
      });

      video.addEventListener('ended', (event) => {
        console.log('video over');
        play.classList.add('is-paused');
        pause.classList.remove('is-playing');
      })
    }
  }

  videoControls();

})
